module.exports = __webpack_public_path__ + "media/icons/receiver-d3cb1d67.svg";